import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OperacionService, GeneralService, RevisionOperacionODSService } from '../../../services/service.index';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
declare var jQuery: any;
declare var toastr;


@Component({
  selector: 'app-rev-operacion_ods',
  templateUrl: './rev-operacion_ods.component.html',
  styles: []
})
export class RevisionOperacionOdsComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  titulo: string = '';
  esLectura: boolean = false;
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  hasError: any;
  poaTecho: any;
  operacion: string ='';
  operaciones: any = [];
  indicadores_ods: any[];
  indicadores_psdi: any[];
  rev_ods_poa: any = { id: 0, codigo_ods: '', codigo_operacion: '', operacion_id: '', acp_id: '', estado_ods: '', ods_id: '', psdi_id:'' };
  id_revision_ods: number = 0;
  techoId: string = '0';
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  ods_descripcion: string = '';
  psdi_descripcion: string = '';

  constructor(private route: ActivatedRoute, private _gs: GeneralService, private _os: OperacionService, private _srev: RevisionOperacionODSService) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    if (this.techoId != '0') {
      this.getOperacionesByByTechoId();
      this.getPoaTecho();
    }

  }
  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          text: 'Actualizar',
        }
      });
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.poaTecho = result.data; }
        else { this.poaTecho = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesByByTechoId() {
    this._srev.getOperacionesByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {                           
          this.operaciones = result.data; 
        }
        else { this.operaciones = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListODS() {
    this._srev.getListODS().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.indicadores_ods = result.data;
        }
        else {
          this.indicadores_ods = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getODSbyId(e: any) {
    this.indicadores_ods.forEach(item => {
      if (item.id == e.value)
        this.ods_descripcion = item.descripcion;
    });
  }

  getListPSDI() {
    this._srev.getListPSDI().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.indicadores_psdi = result.data;
        }
        else {
          this.indicadores_ods = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getPSDIbyId(e: any) {
    this.indicadores_psdi.forEach(item => {
      if (item.id == e.value)
        this.psdi_descripcion = item.descripcion;
    });
  }

  editarRevision(rev: any) {
     this.getListODS();
    this.getListPSDI();
    this.operacion = rev.descripcion;
    this.popupVisibleAdd = true;    
    this.rev_ods_poa.operacion_id = rev.id;      
    if (rev.revision.operacion_id != 0) {
      this.rev_ods_poa.acp_id = rev.id;            
      this.rev_ods_poa.ods_id = rev.revision.ods_id;
      this.rev_ods_poa.psdi_id = rev.revision.psdi_id;      
    }
    else {
      this.rev_ods_poa.ods_id = '';
      this.rev_ods_poa.psdi_id = '';
      this.ods_descripcion = '';
      this.psdi_descripcion ='';
    }
  }


  getIndicadoresODS() {

  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.ods_id, 'integer')) {
      this.hasError.ods_id = true; res = false;
    }
    if (!UtilHelper.validator(data.psdi_id, 'integer')) {
      this.hasError.psdi_id = true; res = false;
    }
    return res;
  }
  registrarRevision(){    
    if (this.validate(this.rev_ods_poa)) {      
        this._srev.postRevisionOperacionODS(this.rev_ods_poa).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getOperacionesByByTechoId();
              this.popupVisibleAdd = false;
              toastr.success('Sisin adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      
      
    }
  }

  showModalDelete(id: number) {    
    this.id_revision_ods = id;
    this.popupVisibleDel = true;
  }

  deleteRevision() {
    this._srev.deleteRevisionOperacionODS(this.id_revision_ods).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getOperacionesByByTechoId();
          this.popupVisibleDel = false;
          toastr.success('Registro eliminado correctamente.');
       
        }else {
          toastr.warning("error al eliminar...");
        }
      },
      error => { console.log('Error', error); });
  }

  getDisplayCod(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.descripcion}`;
  }

  getDisplayOds(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.descripcion}`;
  }

}
